import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const tempProfileChartStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            color: theme.colors.neutrals.neutral500,
            fontSize: "18px",
            lineHeight: "120%",
        },

        container: {
            position: "relative",
            backgroundColor: "white",
        },

        indicatorContainer: {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },

        indicator: {
            width: "100%",
            height: "100%",
            padding: "10%",
        },
    })
);
